export default __webpack_public_path__ + "d4bfc7242cd8e365fc667ed636987604.png";